<p-dialog
    [styleClass]="'date_range_popup'"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [style]="{'width': '60%', 'max-width': '700px'}"
    [modal]="true"
    [visible]="show_DateRangeDialog">

    <ng-template pTemplate="header">
        <div class="flex wd-100 dialog_header_wrapper align-items-center justify-content-between">
            <span class="text-xl font-bold">{{dialog_header}}</span>
            <p-button icon="pi pi-times" (onClick)="hide()"
            styleClass="p-button-rounded p-button-danger p-button-text p-button-raised"></p-button>
        </div>
    </ng-template>

    <div class="date_range_content_wrapper">
        <div class="calendar_container">
            <p-calendar
                [(ngModel)]="selectedDateRange"
                [inline]="true"
                [showButtonBar]="false"
                [numberOfMonths]="2"
                [selectionMode]="'range'"
                [minDate]="minDate"
                [maxDate]="maxDate"
                dateFormat="dd/mm/yy"
                [showOtherMonths]="true"
                [selectOtherMonths]="true"
                styleClass="custom-date-range-calendar">
            </p-calendar>
        </div>

    </div>

    <div class="dialog_footer">
        <div class="footer_buttons">
            <p-button
                type="button"
                label="Apply"
                class="p-button-text elevated-btn primary mr-2"
                [disabled]="!isValidRange"
                (click)="applyDateRange()">
            </p-button>
            <p-button
                type="button"
                label="Cancel"
                class="p-button-text elevated-btn secondary mr-2"
                (click)="hide()">
            </p-button>
        </div>
    </div>
</p-dialog>
